import { render, staticRenderFns } from "./CourseAuthorList.vue?vue&type=template&id=58e6ea46&scoped=true"
import script from "./CourseAuthorList.vue?vue&type=script&lang=js"
export * from "./CourseAuthorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6ea46",
  null
  
)

export default component.exports